import { RouteObject } from 'react-router-dom'
import { preloadQuery } from 'shared/graphql/client'
import { getUserIdFromToken } from 'shared/utils/getUserIdFromToken'
import Notifications from '../shared/pages/Notifications'
import { GetCandidateProfileForCandidate } from './graphql/generatedProfile.gql'
import { GetCandidateRecruitingPreferences } from './graphql/recruitingPreferences.gql'
import Complete from './pages/Complete'
import Dashboard from './pages/Dashboard'
import Questions from './pages/Intakes/Questions'
import JobBoard from './pages/JobBoard'
import Preferences from './pages/Preferences'
import Profile from './pages/Profile'
import Schedule from './pages/Schedule'

export const candidateRouteConfig = {
    dashboard: {
        path: '/dashboard',
    },
    profile: {
        path: '/profile',
    },
    schedule: {
        path: '/schedule',
    },
    preferences: {
        path: '/preferences',
    },
    notifications: {
        path: '/notifications',
    },
    jobboards: {
        path: '/job',
    },
    intakes: {
        basePath: 'intakes',
        intake: {
            path: '/intakes/intake',
        },
        complete: {
            path: '/intakes/complete',
        },
    },
}

const CandidateRoutes: RouteObject[] = [
    {
        path: candidateRouteConfig.dashboard.path,
        element: <Dashboard />,
    },
    {
        path: candidateRouteConfig.profile.path,
        element: <Profile />,
        loader: async () => {
            const id = getUserIdFromToken()
            if (!id) throw new Error('No user id found')
            const queryRef = await preloadQuery(
                GetCandidateProfileForCandidate,
                { variables: { userId: id } }
            ).toPromise()
            return queryRef
        },
    },
    {
        path: candidateRouteConfig.schedule.path,
        element: <Schedule />,
    },
    {
        path: `${candidateRouteConfig.jobboards.path}/:jobBoardId`,
        element: <JobBoard />,
    },
    {
        path: candidateRouteConfig.notifications.path,
        element: <Notifications />,
    },
    {
        path: `${candidateRouteConfig.intakes.intake.path}/:candidateIntakeId`,
        element: <Questions />,
    },
    {
        path: candidateRouteConfig.intakes.complete.path,
        element: <Complete />,
    },
    {
        path: candidateRouteConfig.preferences.path,
        element: <Preferences />,
        loader: async () => {
            const id = getUserIdFromToken() ?? ''
            const queryRef = await preloadQuery(
                GetCandidateRecruitingPreferences,
                {
                    variables: { id },
                }
            ).toPromise()
            return queryRef
        },
    },
]

export default CandidateRoutes
